import { IIconProps } from '#components/icons/types';

const ChevronLeft = ({ size = 48, color = '#fff' }: IIconProps) => (
  <svg
    className="svg-icon"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill={color}
  >
    <path d="M0 0h24v24H0V0z" fill="none" stroke="none" />
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />
  </svg>
);

export default ChevronLeft;
